/** @format */

import React from "react";
import { Box } from "./MuiCompat";

const fontInter = `'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif`;

const Navigate: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        py: { xs: 14, md: 22 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "var(--page-max-width)",
          mx: "auto",
          px: { xs: 3, sm: 5, md: 8 },
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          aria-hidden
          sx={{
            width: "1px",
            height: 56,
            background:
              "linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.18))",
            mb: { xs: 4, md: 6 },
          }}
        />

        <Box
          component="h2"
          sx={{
            m: 0,
            maxWidth: "680px",
            fontFamily: fontInter,
            fontWeight: 600,
            fontSize: "clamp(2.6rem, 6vw, 5rem)",
            lineHeight: 1.04,
            letterSpacing: "-0.024em",
            color: "var(--color-snow)",
          }}
        >
          EON helps You{" "}
          <Box
            component="span"
            sx={{
              fontStyle: "italic",
              fontWeight: 500,
              backgroundImage:
                "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(86, 194, 255, 0.92) 130%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            navigate
          </Box>{" "}
          it.
        </Box>

        <Box
          sx={{
            mt: { xs: 4, md: 5 },
            maxWidth: "680px",
            fontFamily: fontInter,
            fontSize: "clamp(1.05rem, 1.4vw, 1.3rem)",
            fontWeight: 400,
            lineHeight: 1.5,
            color: "rgba(255, 255, 255, 0.7)",
          }}
        >
          Your agent maps the complexity. Runs the experiments. Quietly keeps
          you moving.
        </Box>
      </Box>
    </Box>
  );
};

export default Navigate;
